export default __webpack_public_path__ + "static/media/logo.fc33d41d.png";